/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { jingleModelSchema } from "./jingleModelSchema.ts";
import { z } from "zod";

export const jingleModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => jingleModelSchema))
    })